import { useMemo } from 'react'

// TODO: this should probably be renamed, is this hook does not return ROOT but url without first piece
export const useHostnameRootUrl = (scope = window) => {
  const host = scope.location.hostname
  return useMemo(() => {
    if (host.includes('.') && !host.includes('local')) {
      const pieces = host.split('.')
      if (pieces.length > 2) {
        pieces.shift()
      }

      return `//${pieces.join('.')}`
    }

    return '/'
  }, [host])
}
